import { MapContainer, Marker, TileLayer, useMap } from "react-leaflet";
import cleancitylogo from "../assets/cleancitylogo.png";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import useAuth from "../context/useAuth";
import { getFillStatus } from "../api/detailed";

const DetailedDataMap = ({ athensCenter, markers, openModal, serial }) => {
    const zoom = 15;
    const { ccnUrl } = useAuth();
    const [data, setData] = useState([]);

    useEffect(() => {
        let isCurrent = true; // for race condition
        setData([]); // Reset immediately when serial changes
        getFillStatus(serial)
            .then((res) => {
                if (isCurrent) setData(res.data.details);
            })
            .catch((err) => {
                if (isCurrent) setData([]); // Optionally handle error state
            });
        return () => { isCurrent = false; };
    }, [serial]);

    const CenterUpdater = ({ center }) => {
        const map = useMap();
        useEffect(() => {
            map.setView(center);
        }, [center, map]);
        return null;
    };

    return (
        <Box style={{ width: '500px', margin: '0 20px' }}>
            <MapContainer
                center={athensCenter}
                zoom={zoom}
                style={{
                    height: '300px',
                    width: '100%',
                    borderRadius: '10px'
                }}
            >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <CenterUpdater center={athensCenter} />
                {markers.map((marker, index) => (
                    <Marker key={index} position={marker.position} />
                ))}
            </MapContainer>

            <div className="flex p-4 border rounded-md bg-white shadow-md w-full mt-2">
                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start'
                }}>
                    <img alt="logo"
                        style={{
                            maxWidth: '30px',
                            maxHeight: '40px',
                            height: 'auto',
                            margin: '10px 0',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.open(ccnUrl, '_blank')}
                        src={cleancitylogo}
                    />
                </div>
                <div className="flex gap-4 w-full">
                    {data && data.length === 0 ? (
                        <div className="text-gray-500 text-sm">Δεν υπάρχουν δεδομένα</div>
                    ) : (
                        data.map((item, index) => (
                            <div key={index} className="flex flex-col items-center">
                                <div className="w-20 flex justify-center text-sm align-middle ">
                                    <span>
                                        {item.localSerial.charAt(0)}{item.localSerial.match(/\d(?=\D*$)/)?.[0]}
                                    </span>
                                    <div onClick={() => openModal(item?.localSerial)}
                                        className="w-4 h-4 bg-blue-700 ml-1 mt-0.5 text-white text-xs flex items-center justify-center rounded-full cursor-pointer">
                                        i
                                    </div>
                                </div>
                                <span>
                                    {item.type}
                                </span>
                                <div className="w-full h-2 bg-gray-300 rounded overflow-hidden mt-2">
                                    <div
                                        className="h-full"
                                        style={{
                                            width: `${item.fillLevel}%`,
                                            backgroundColor: `${item.fillLevel < 60
                                                ? '#8BC34A'
                                                : item.fillLevel < 80
                                                    ? '#FFC107'
                                                    : '#F44336'}`
                                        }}
                                    />
                                </div>
                                <div className="text-sm mt-1">
                                    {item.fillLevel}%
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </Box>
    );
};

export default DetailedDataMap;
